import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BlogCTAButtons from "@/components/BlogCTAButtons";
import CanonicalTag from "@/components/CanonicalTag";
import FloatingADUWizard from "@/components/FloatingADUWizard";
import FloatingReserveButton from "@/components/FloatingReserveButton";
import heroImage from "@/assets/simple-adus-faster-permits.png";

const BlogSimpleADUsFasterPermits = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": "Simple ADUs That Move Faster Through Permits",
    "description": "Faster approvals, less complexity, predictable timelines. Learn why simpler ADUs often outperform complex ones.",
    "datePublished": "2026-04-08",
    "author": { "@type": "Organization", "name": "UDA ADU" },
    "publisher": { "@type": "Organization", "name": "UDA ADU" },
  };

  return (
    <div className="min-h-screen bg-background">
      <CanonicalTag url="https://www.udaadu.com/blogs/simple-adus-faster-permits" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />
      <Navigation />
      <div className="w-full max-w-5xl mx-auto px-4 pt-8">
        <img src={heroImage} alt="Simple ADUs that move faster through permits" className="w-full rounded-2xl" />
      </div>
      <main className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/blogs" className="inline-flex items-center text-muted-foreground hover:text-foreground mb-8 transition-colors">
          <ArrowLeft className="h-4 w-4 mr-2" /> Back to Blog
        </Link>
        <p className="text-sm text-muted-foreground mb-2">April 8, 2026</p>
        <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-8">Simple ADUs That Move Faster Through Permits</h1>
        <article className="prose prose-lg max-w-none text-muted-foreground space-y-6">
          <p>Not every project needs to be complex.</p>
          <p>In many cases, simpler ADUs move faster through city approvals and are easier to build.</p>
          <p>Clean layouts, straightforward designs, and fewer structural complications help keep timelines predictable.</p>
          <p>We often recommend starting simple, especially in cities with strict permitting.</p>
          <p>A well-executed simple ADU can outperform a complicated one.</p>
        </article>
        <BlogCTAButtons />
      </main>
      <FloatingADUWizard />
      <FloatingReserveButton />
      <Footer />
    </div>
  );
};

export default BlogSimpleADUsFasterPermits;
